/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/DetailStatsItemModel',['MenuUI/StatsItemModel', 'Solitaire/SolitaireStatistics', 'Solitaire/SolitaireGameMode'], function (StatsItemModel, SolitaireStatistics, SolitaireGameMode) {
    "use strict";


    //var modes = ["1STANDARDKLONDIKE", "1LASVEGASKLONDIKE", "3STANDARDKLONDIKE", "3LASVEGASKLONDIKE", "1LASVEGASCUMULATIVEKLONDIKE", "3LASVEGASCUMULATIVEKLONDIKE"];



    var _statLabels = {
        "klondike": [ "GamesPlayed", "GamesWon", "GamesLost", "PercentWon", "WinningStreak", "LongestWinningStreak", "LongestLosingStreak", "HighScore", "AverageScore", "BestTime", "AverageTime"],
        "spider": ["GamesPlayed", "GamesWon", "GamesLost", "PercentWon", "HighScore", "AverageScore", "BestTime", "AverageTime", "Stacks", "AverageStacks"],
        "freecell": ["GamesPlayed", "GamesWon", "GamesLost", "PercentWon", "BestTime", "AverageTime"],
        "pyramid": ["GamesPlayed", "HighScore", "HighestBoards", "Boards", "AverageBoards", "HighestRowsCleared", "RowsCleared", "AverageRowsCleared", "HighestMatches", "Matches", "AverageMatches"],
        "tripeaks": ["GamesPlayed", "HighScore", "HighestBoards", "Boards", "AverageBoards", "HighestPeaksCleared", 'PeaksCleared', "AveragePeaksCleared", "LongestCardsChained"]

    };

    var DetailStatsItemModel = function (gameMode) {
        this.initDetailStatsItemModel(gameMode);
    };

    DetailStatsItemModel.prototype.initDetailStatsItemModel = function (gameMode) {
        this._gameMode = gameMode;
        this._statsItemModels = [];
        this.buildStatsItemModels();
    };

    Object.defineProperty(DetailStatsItemModel.prototype, "StatsItemModels", {
        get: function () {
            return this._statsItemModels;
        }
    });

    DetailStatsItemModel.prototype.buildStatsItemModels = function () {

        var statsItemKeys = SolitaireStatistics.Current.GetKeys(this._gameMode);

        for (var i = 0; i < statsItemKeys.length; i++) {
            var statLabels = _statLabels[SolitaireGameMode.getModeById(this._gameMode).toLowerCase()],
                model = new StatsItemModel(this._gameMode);

            model.addStats(statLabels, SolitaireStatistics.Current.GetAllStats, statsItemKeys[i]);
            model.updateStats();

            this._statsItemModels.push(model);
        }

    };



    return DetailStatsItemModel;
});

